import React from 'react'
import { transparentize } from 'polished'
import styles from './Spinner.m.sass'

export interface SpinnerProps {
  color?: string
  size?: number
  thickness?: number
}

const Spinner = (props: SpinnerProps) => (
  <div className={styles.root}>
    <div className={styles.icon} style={getIconStyle(props)} />
  </div>
)

export default Spinner

const getIconStyle = ({
  color = 'var(--theme-base)',
  size = 24,
  thickness = 2,
}: SpinnerProps) => {
  const offColor =
    // Temporary until we can grab theme stuff more easily
    color === 'var(--theme-base)'
      ? 'var(--theme-lighten)'
      : transparentize(0.8, color)
  return {
    borderColor: offColor,
    borderTopColor: color,
    width: size,
    height: size,
    borderWidth: thickness,
  }
}
